module.exports = __webpack_public_path__ + "img/case02.47124eea.jpg";